import { useState } from "react"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { SearchIcon } from "lucide-react"
import type { FaxNumber } from "./types"

type FromSelectProps = {
  numbers: FaxNumber[]
  value: string
  onChange: (value: string) => void
}

export function FromSelect({ numbers, value, onChange }: FromSelectProps) {
  const [filtered, setFiltered] = useState<FaxNumber[]>(numbers)

  return (
    <div className="space-y-2 w-full">
      <Label htmlFor="from">From</Label>
      <Select
        value={value}
        onValueChange={(v) => {
          onChange(v || "")
          setFiltered(numbers)
        }}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select a number" />
        </SelectTrigger>
        <SelectContent>
          <div className="flex items-center border-b px-2">
            <Input
              type="text"
              placeholder="Search numbers..."
              onChange={(e) => {
                const term = e.target.value.toLowerCase()
                setFiltered(
                  numbers.filter(
                    (n) =>
                      n.name.toLowerCase().includes(term) ||
                      n.number.toLowerCase().includes(term)
                  )
                )
              }}
              className="m-2"
            />
          </div>
          <SelectGroup>
            {filtered.map((n) => (
              <SelectItem key={n.number} value={n.number}>
                <span className="font-medium">{n.name}</span>
                <span className="ml-2 text-muted-foreground">{n.number}</span>
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  )
}
